import { useSelector } from 'react-redux';

import { RootState } from '../store/configureStore';

export function getSelectorByKey<K extends keyof RootState>(key: K): RootState[K] {
  return useSelector((state: RootState) => state[key]);
}
